import RebateList from './index'

export default { path: '/home/rebateRisk', component: RebateList }
